import type { PDFDocumentProxy } from 'pdfjs-dist/web/pdf_viewer';
import React from 'react';

import { Deal } from '../../../Types/deal';
import { Quotation } from '../../../Types/quotation';

interface DealContextProps {
  deal: Deal;
  quotation: Quotation;
  pdf: PDFDocumentProxy;
}

const DealContext = React.createContext<Partial<DealContextProps>>({});

export default DealContext;
